<template>
<div>
    <vue-headful
      title="Take It All In Responsibly - Alabama.Travel"
      description="We’re making Alabama a safe destination for you."
      url="https://alabama.travel/my-trip/staying-safe/responsibly"/>
    <div class="responsibly">
      <Banner :bannerId="sp.headerImage" type="image"
      :description="sp.altDescription" :imageAlt="page.fields.header_image_alt_text" />
      <div class="banner-logo"><img :src="sp.bannerLogo" :alt="page.fields.banner_alt_text" role="presentation"/></div>
      <section class="container">
        <div class="row">
          <div class="col-lg-12 mt-5">
            <nav aria-label="breadcrumbs" class="safety-breadcrumb mt-3">
              <b-breadcrumb >
                <b-breadcrumb-item v-for="breadcrumb in Breadcrumbs" :key="breadcrumb.id" :text="breadcrumb.text" :to="breadcrumb.href" :active="breadcrumb.active" />
              </b-breadcrumb>
            </nav>
            <h1 class="mt-5">{{sp.title}}</h1>
          </div>
          <div class="col-lg-4 sub-title-wrapper text-left">
            <div class="left-content">{{sp.introTitle}}</div>
          </div>
          <div class="col-lg-7 mt-5 desc-wrapper text-left offset-lg-1">
            <div class="right-content">{{sp.introText}}
              <div v-if="sp && sp.locations && sp.locations.length > 0" class="mt-3">
                <a href="#responsibly-map" class="sp-button"><span>{{sp.buttonText}}</span></a>
              </div>
            </div>
          </div>
          <div class="col-lg-12 mt-100">
            <figure class="pledge-icon">
              <img :src="sp.pledgeIcon" :alt="page.fields.image_alt_text" role="presentation" class="small-icon">
            </figure>
            <h2 class="mt-3">{{sp.pledgeTitle}}</h2>
            <div class="content">{{sp.pledgeText}}</div>
          </div>
          <div class="col-lg-12 mt-section pledges">
            <div class="col-lg-6 float-left">
              <h2>{{sp.blockTitle_left}}</h2>
              <div class="mt-3 block-container" v-for="(block, index) in sp.ourPledgeBlocks" :key="index">
                <div class="block-icon">
                  <img :src="block.icon" alt="" role="presentation" class="">
                </div>
                <div class="block-content">{{block.content}}</div>
              </div>
            </div>
            <div class="col-lg-6 float-right">
              <h2>{{sp.blockTitle_right}}</h2>
              <div class="mt-3 block-container" v-for="(block, index) in sp.yourPledgeBlocks" :key="index">
                <div class="block-icon">
                  <img :src="block.icon" :alt="block.image_alt_text" role="presentation" class="">
                </div>
                <div class="block-content">{{block.content}}</div>
              </div>
            </div>
          </div>
          <div class="block-button-div col-lg-6">
            <a v-if="sp.blockButtonLink.includes('http')" :href="sp.blockButtonLink"  :aria-label="`${sp.blockButtonText} opens in a new window`"  rel='noopener' target='_blank' class="block-button"><span>{{sp.blockButtonText}}</span></a>
            <a  v-else :href="sp.blockButtonLink" class="block-button"><span>{{sp.blockButtonText}}</span></a>
          </div>
          <div class="block-button-div col-lg-6">
            <a v-if="sp.blockButtonLink2.includes('www')" :href="'//' + sp.blockButtonLink2"  aria-label="opens in a new window" rel='noopener' target='_blank' class="block-button"><span>{{sp.blockButtonText2}}</span></a>
            <a  v-else :href="sp.blockButtonLink2" class="block-button"><span>{{sp.blockButtonText2}}</span></a>
          </div>
          <div v-if="sp && sp.locations && sp.locations.length > 0" class="col-lg-12 mt-100">
            <h2>{{sp.mapHeading}}</h2>
            <div class="content mt-3">{{sp.mapIntro}}</div>
          </div>
        </div>
      </section>
      <ExperienceList v-on:reloadExperiencesMap="reloadExperiencesMap" v-if="sp && sp.locations && sp.locations.length > 0 && loaded"
        :experienceTitle="sp.mapTitle ? sp.mapTitle : ''"
        :results_title="sp.mapTitle ? sp.mapTitle : ''"
        :locations="sp.locations"
        mapDestinationType="Responsibly"
        slug="/my-trip/staying-safe/responsibly"
        ariaLabel="Find a Covid-19 Safety Program"
        id="responsibly-map" class="mb-100" />
        <section v-if="sp.callOut_header" class="container">
          <div v-if="sp.locations.length === 0" class="mb-100" ></div>
          <div class="row">
            <div class="col-lg-6  d-flex flex-column justify-content-center">
              <div class="call-out-video video-container video-mobile">
                <div v-html="sp.callOut_video" class="image-fluid youtube-container embed-responsive embed-responsive-21by9" alt="" role="presentation"></div>
              </div>
            </div>
            <div class="col-lg-6 mt-5 d-flex flex-column justify-content-center">
              <h2 class=""> {{sp.callOut_header}} </h2>
              <p v-html="sp.callOut_text"></p>
              <div v-if="sp.callOutButton_link != ''" class="block-button-div">
                <a v-if="sp.callOutButton_link.includes('www')" :href="'//' + sp.callOutButton_link"  aria-label="opens in a new window" rel='noopener' target='_blank' class="block-button"><span>{{sp.callOutButton_text}}</span></a>
                <a v-else :href="sp.callOutButton_link" class="block-button"><span>{{sp.callOutButton_text}}</span></a>
              </div>
            </div>
          </div>
        </section>
      </div>
    <Footer/>
  </div>
</template>

<script>
import { Vue, Component } from 'vue-property-decorator';
import axios from 'axios';
import Butter from 'buttercms';
import Footer from '@/components/Common/Footer.vue';
import Banner from '@/components/Common/Banner.vue';
import ExperienceList from '@/components/Experiences/Common/ExperienceList.vue';
import DetailHeader from '@/components/PlacesToGo/Common/DetailHeader.vue';

export const butter = Butter('eb418357164849860c223876bb84811162582149');

@Component({
  data() {
    return {
      responsibly_badge_id: process.env.VUE_APP_BADGEID2,
      page: {
        fields: {},
      },
      breadcrumb: {
        text: 'Staying Safe',
        href: '/my-trip/staying-safe',
      },
      loaded: false,
      sp: {
        headerImage: null,
        altDescription: null,
        bannerLogo: null,
        title: null,
        introTitle: null,
        introText: null,
        buttonText: null,
        buttonLink: null,
        pledgeIcon: null,
        pledgeTitle: null,
        pledgeText: null,
        blockTitle: null,
        blockIntro: null,
        locations: [],
        blockTitle_left: null,
        ourPledgeBlocks: [{}],
        blockTitle_right: null,
        yourPledgeBlocks: [{}],
        blockButtonText: null,
        blockButtonLink: '',
        blockButtonText2: null,
        blockButtonLink2: '',
        mapHeading: null,
        mapIntro: null,
        mapTitle: null,
        callOut_video: null,
        callOut_header: null,
        callOut_text: null,
        callOutButton_text: null,
        callOutButton_link: '',
      },
    };
  },
  components: {
    ExperienceList,
    DetailHeader,
    Footer,
    Banner,
  },
  methods: {
    reloadExperiencesMap(bounds) {
      const ne = bounds.getNorthEast();
      const sw = bounds.getSouthWest();
      const params = `&min_latitude=${sw.lat()}&min_longitude=${ne.lng()}&max_latitude=${ne.lat()}&max_longitude=${sw.lng()}`;
      this.getAlabamaLocations(params);
    },
    getPage() {
      butter.page.retrieve('*', 'safety-program', { preview: `${process.env.VUE_APP_BUTTER_PREVIEW}` })
        .then((res) => {
          this.page = res.data.data;
          this.sp.headerImage = this.page.fields.header_image;
          this.sp.altDescription = this.page.fields.alt_description;
          this.sp.bannerLogo = this.page.fields.banner_logo;
          this.sp.title = this.page.fields.title;
          this.sp.introTitle = this.page.fields.intro_title;
          this.sp.introText = this.page.fields.intro_text;
          this.sp.buttonText = this.page.fields.button_text;
          this.sp.buttonLink = this.page.fields.button_link;
          this.sp.pledgeIcon = this.page.fields.pledge_icon;
          this.sp.pledgeTitle = this.page.fields.pledge_title;
          this.sp.pledgeText = this.page.fields.pledge_text;
          this.sp.blockTitle = this.page.fields.block_title;
          this.sp.blockIntro = this.page.fields.block_intro;
          this.sp.blockTitle_left = this.page.fields.block_title_left;
          this.sp.ourPledgeBlocks = this.page.fields.our_pledge_blocks;
          this.sp.blockTitle_right = this.page.fields.block_title_right;
          this.sp.yourPledgeBlocks = this.page.fields.your_pledge_blocks;
          this.sp.blockButtonText = this.page.fields.block_button_text;
          this.sp.blockButtonLink = this.page.fields.block_button_link;
          this.sp.blockButtonText2 = this.page.fields.block_button_text_2;
          this.sp.blockButtonLink2 = this.page.fields.block_button_link_2;
          this.sp.mapHeading = this.page.fields.map_heading;
          this.sp.mapIntro = this.page.fields.map_intro;
          this.sp.mapTitle = this.page.fields.map_title;
          this.sp.callOut_video = this.page.fields.call_out_video;
          this.sp.callOut_header = this.page.fields.call_out_header;
          this.sp.callOut_text = this.page.fields.call_out_text;
          this.sp.callOutButton_text = this.page.fields.call_out_button_text;
          this.sp.callOutButton_link = this.page.fields.call_out_button_link;
        }).catch((res) => {
          console.log(res);
        });
    },
    async getAlabamaLocations(params) {
      const badge = this.responsibly_badge_id;
      await axios.get(`${process.env.VUE_APP_API2}filterLocations?badge_ids=${badge}${params}`, {
        headers: {
          'Access-Control-Allow-Origin': '*',
          Accept: 'application/json',
        },
      }).then((response) => {
        this.$nextTick(() => {
          const { locations } = response.data;
          let count = locations.length;
          let temp;
          let index;
          // shuffle
          while (count > 0) {
            // Pick a random index
            index = Math.floor(Math.random() * count);
            // Decrease count by 1
            count--;
            // And swap the last element with it
            temp = locations[count];
            locations[count] = locations[index];
            locations[index] = temp;
          }
          this.sp.locations = locations;
          this.loaded = true;
        });
      });
    },
  },
  async created() {
    await this.getPage();
    await this.getAlabamaLocations('');
  },
})
class StaySafe extends Vue {
  get Breadcrumbs() {
    return [
      {
        text: this.breadcrumb.text,
        href: this.breadcrumb.href,
      },
    ];
  }
}

export default StaySafe;
</script>

<style lang="scss" scoped>
.mb-100 { margin-bottom: 100px; }
.mt-100 { margin-top: 100px; }
.call-out-video {
  display: flex;
  align-items: center;
  justify-content: center;
  width:100%;
}
.video-container {
  width: 100%;
  height: 100%;
  margin-left: 0%;
  margin-right: 0%;
}
.float-left { float: left; }
.float-right { float: right; }
.banner-logo {
  margin: 0 auto;
  position: absolute;
  top:325px;
  width:100%;
  z-index: 2;
}
.banner-logo img {
  width: 275px;
}
.breadcrumb { padding: 0px;}
.breadcrumb-item {
  font-family: 'klinicslabmedium';
  font-size: 30px;
}
.breadcrumb-item a {color: #173945!important;}
.safety-breadcrumb {
  align-items: center;
  display: flex;
  justify-content: center;
}
.mt-section {
  margin-top: 60px;
}
.sp-button-div a span {
  margin: auto;
}
.sp-button {
    align-items: center;
    background-color: #fff;
    border: solid 1px #173945;
    border-radius: 0.25rem;
    color: #2c3e50;
    display: flex;
    font-family: 'IdealSans-Medium';
    font-size: 12px;
    height: 40px;
    justify-content: center;
    padding: 10px;
    -webkit-transition: background-color 500ms;
    transition: background-color 500ms;
    text-decoration: underline;
    width: 190px;

  &:hover,
  &:active,
  &:focus {
    background-color: #d6e7ee;
    color: #4e97b2;
  }
}
.content {
  color: #000000;
  font-family: 'IdealSans-Book','Avenir', Helvetica, Arial, sans-serif;;
  font-size: 1.2rem;
  font-weight: 400;
  height: auto;
  letter-spacing: normal;
  line-height: 1.56;
  margin: auto;
  text-align: center;
  width: 620px;
}
.block-container {
  align-items: center;
  display: flex;
  height: 165px;
  margin: auto;
  padding: 15px;
  width: 100%;
}
.block-container:nth-child(odd) {
  background-color: #d6e7ee;
  border-radius: var(--spacing-xxs);
}
.block-icon {
  float: left;
  margin-bottom: 0px;
  width: 120px;
}
.block-content {
  float: right;
  margin-left: 20px;
  text-align: left;
  width: 70%;
}
.block-button-div {
  margin-bottom: 20px;
}
.block-button {
  background-color: #fff;
  border: solid 1px #173945;
  border-radius: 5px;
  color: #2c3e50;
  display: inline-block;
  font-family: 'IdealSans-Medium';
  font-size: 1.1rem;
  font-weight: 500;
  min-height: 50px;
  padding: 15px 35px 10px 25px;
  position: relative;
  -webkit-transition: background-color 500ms;
  transition: background-color 500ms;
  text-decoration: underline;

  &:hover,
  &:active,
  &:focus {
    background-color: #d6e7ee;
    color: #4e97b2;
  }
}
.pledges {
  margin-bottom: 40px;
}
.pledge-icon {
  border-radius: 50%;
  display: flex;
  margin: auto;
}
.pledge-block-callouts {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  margin-top: 50px;
}
.pledge-box-item{
  display: flex;
  flex-direction: column;
  padding: 20px;
  width: 100%;
}
.pledge-box-item-content {
  flex: 1 0 auto;
}
.small-icon {
  margin: auto;
  width: 300px;
}
.sub-title-wrapper {
  align-items: center;
  border-right: solid 1px #4e97b2;
  display: flex;
  height: 350px;
  justify-content: center;
  margin-top: 50px;
  width: 100%;
}
.desc-wrapper {
  align-items: center;
  display: flex;
  height: 300px;
  justify-content: center;
  width: 100%;
}
.left-content {
  color: #173945!important;
  font-family: 'klinicslabmedium';
  font-size: 34px;
  font-stretch: normal;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  height: 170px;
  margin: auto;
  text-align: center;
  width: 220px;
}
.right-content {
  align-items: center;
  color: #173945!important;
  font-family: 'IdealSans-Medium';
  font-size: 1.2rem;
  font-stretch: normal;
  font-style: normal;
  font-weight: 500;
  height: 200px;
  justify-content: center;
  line-height: 32px;
  letter-spacing: normal;
  margin: auto;
  width: 850px;
}
@media only screen and (max-width: 1366px) {
  .banner-logo { top: 200px; }
}
@media only screen and (max-width: 1024px) {
  .banner-logo img {
    width: 200px;
  }
  .desc-wrapper {
    height: 400px;
    margin-top: 3px!important;
  }
}
@media only screen and (max-width: 812px) {
  .banner-logo {
    margin: 0 auto;
    position: absolute;
    top:170px;
    width:100%;
    z-index: 2;
  }
  .banner-logo img {
    width: 180px;
  }
  .block-icon { width: 100px; }
  .container { padding:0 20px; }
  .content { width: unset; }
  .desc-wrapper { height: 350px; }
  .float-right { margin-top: 50px; }
  .left-content {
    height: 80px;
    width: 325px;
  }
  .mb-300 { margin-bottom: 300px; }
  .right-content { text-align: center; }
  .sp-button { margin: auto; }
  .sub-title-wrapper {
    border-right: none;
    height: 150px;
  }
}
@media only screen and (max-width: 414px) {
  .banner-logo { top:150px; }
  .banner-logo img { width: 100px; }
  .block-button-div {
    margin-left: auto;
    margin-right: auto;
  }
  .block-container:nth-child(even) { height: auto; }
  .block-container:nth-child(odd) { height: auto; }
  .block-title { width: 185px; }
  .desc-wrapper { height: 600px; }
  .right-content { height: 400px; }
}
@media only screen and (max-width: 360px) {
  .banner-logo { top: 170px; }
  .desc-wrapper { height: 800px; }
  .right-content { height: 600px; }
}
</style>
